/* LYOSHAIR · interacciones del tema */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- Carrito AJAX ---------- */
  const countEls = () => $$('[data-cart-count]');
  function setCount(n) {
    countEls().forEach(el => { el.textContent = n; el.hidden = n === 0; });
  }
  let toastTimer;
  function toast(title, image) {
    const t = $('#CartToast'); if (!t) return;
    $('.toast__n', t).textContent = title || '';
    const img = $('img', t);
    if (image) { img.src = image; img.hidden = false; } else { img.hidden = true; }
    t.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-open'), 4200);
  }
  document.addEventListener('click', e => { if (e.target.closest('[data-toast-close]')) $('#CartToast').classList.remove('is-open'); });

  async function addItems(items) {
    const res = await fetch(window.LYOS.routes.cart_add + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || 'No se pudo agregar'); }
    const cart = await (await fetch(window.LYOS.routes.cart + '.js')).json();
    setCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('lyos:cart', { detail: cart }));
    return cart;
  }
  window.LYOS.addItems = addItems;

  function flash(btn, ok) {
    const label = btn.querySelector('span');
    const prev = label ? label.textContent : null;
    btn.classList.remove('is-loading');
    if (ok) {
      btn.classList.add('is-added');
      if (label) label.textContent = 'Agregado';
      setTimeout(() => { btn.classList.remove('is-added'); if (label) label.textContent = prev; }, 1800);
    }
  }

  // Botones "Agregar" de tarjetas y filas
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      await addItems([{ id: Number(btn.dataset.addToCart), quantity: 1 }]);
      flash(btn, true);
      if (btn.hasAttribute('data-reload')) { setTimeout(function () { location.reload(); }, 500); return; }
      toast(btn.dataset.title, btn.dataset.image);
    } catch (err) { flash(btn, false); alert(err.message); }
  });

  // Botón de kit: agrega varios productos de una vez
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-add-kit]');
    if (!btn) return;
    e.preventDefault();
    const ids = btn.dataset.addKit.split(',').filter(Boolean).map(id => ({ id: Number(id), quantity: 1 }));
    if (!ids.length) return;
    btn.classList.add('is-loading');
    try {
      await addItems(ids);
      btn.classList.remove('is-loading');
      toast(btn.dataset.title || 'Kit de Restauración', btn.dataset.image);
    } catch (err) { btn.classList.remove('is-loading'); alert(err.message); }
  });

  // Formularios de producto (ficha) con AJAX
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    btn && btn.classList.add('is-loading');
    try {
      await addItems([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }]);
      btn && btn.classList.remove('is-loading');
      toast(form.dataset.title, form.dataset.image);
    } catch (err) { btn && btn.classList.remove('is-loading'); alert(err.message); }
  });

  /* ---------- Menú móvil y búsqueda ---------- */
  const drawer = $('[data-drawer]') || document.createElement('div');
  document.addEventListener('click', e => {
    if (e.target.closest('[data-drawer-open]')) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-drawer-close]')) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    if (e.target.closest('[data-search-open]') && $('[data-search]')) { const s = $('[data-search]'); s.classList.add('is-open'); setTimeout(() => $('input[type=search]', s).focus(), 200); }
    if (e.target.closest('[data-search-close]')) $('[data-search]').classList.remove('is-open');
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { drawer && drawer.classList.remove('is-open'); $('[data-search]') && $('[data-search]').classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* ---------- Aparición al hacer scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px 12% 0px' }) : null;
  function observe(root = document) { $$('.reveal:not(.is-in)', root).forEach(el => io ? io.observe(el) : el.classList.add('is-in')); }
  observe();
  document.addEventListener('shopify:section:load', e => observe(e.target));
  window.LYOS.observe = observe;

  /* ---------- Entrada del Home ---------- */
  function revealHero() {
    $$('.hero--pre').forEach(h => { void h.offsetWidth; h.classList.remove('hero--pre'); setTimeout(() => h.classList.remove('hero--intro'), 3000); });
  }
  const intro = $('[data-intro]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(revealHero));
  const designMode = window.Shopify && window.Shopify.designMode;
  if (intro && !document.documentElement.classList.contains('intro-seen') && !reduce && !designMode) {
    document.body.style.overflow = 'hidden';
    let finished = false;
    const done = () => {
      if (finished) return; finished = true;
      intro.classList.add('is-done');
      document.body.style.overflow = '';
      setTimeout(revealHero, 250);
      setTimeout(() => intro.remove(), 1100);
      try { sessionStorage.setItem('lyos-intro', '1'); } catch (e) {}
    };
    setTimeout(done, 1300);
  } else {
    if (intro) intro.remove();
    requestAnimationFrame(() => requestAnimationFrame(revealHero));
  }

  /* ---------- Puente animado (alisados -> kit) ---------- */
  const bridgeIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); bridgeIO.unobserve(en.target); } }), { threshold: 0.4 }) : null;
  $$('[data-bridge]').forEach(b => bridgeIO ? bridgeIO.observe(b) : b.classList.add('is-in'));

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(slider => {
    const slides = $$('[data-slide]', slider);
    if (slides.length < 2) return;
    let i = 0, timer;
    const cur = $('[data-slider-current]', slider), bar = $('[data-slider-bar]', slider), nxt = $('[data-slider-upcoming]', slider);
    const ms = Number(slider.dataset.interval || 7000);
    // La barra se llena durante el tiempo del slide: "cargando el siguiente"
    const runBar = () => {
      if (!bar) return;
      bar.style.transition = 'none'; bar.style.width = '0%';
      void bar.offsetWidth;
      bar.style.transition = `width ${ms}ms linear`; bar.style.width = '100%';
    };
    const go = n => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k !== i); s.inert = k !== i; });
      slider.dataset.theme = slides[i].dataset.theme || 'light';
      if (cur) cur.textContent = String(i + 1).padStart(2, '0');
      if (nxt) nxt.textContent = String(((i + 1) % slides.length) + 1).padStart(2, '0');
      runBar();
      $$('[data-slider-label]', slider).forEach(l => l.textContent = slides[(i + 1) % slides.length].dataset.label || '');
    };
    const auto = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), ms); };
    $('[data-slider-prev]', slider)?.addEventListener('click', () => { go(i - 1); auto(); });
    $('[data-slider-next]', slider)?.addEventListener('click', () => { go(i + 1); auto(); });
    let x0 = null;
    slider.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); auto(); } x0 = null; });
    go(0); auto();
  });

  /* ---------- Pestañas de productos ---------- */
  $$('[data-tabs]').forEach(wrap => {
    const tabs = $$('[data-tab]', wrap), panels = $$('[data-panel]', wrap);
    tabs.forEach(t => t.addEventListener('click', () => {
      tabs.forEach(x => x.setAttribute('aria-selected', x === t));
      panels.forEach(p => { p.hidden = p.dataset.panel !== t.dataset.tab; if (!p.hidden) observe(p); });
    }));
  });

  /* ---------- Galería de producto ---------- */
  $$('[data-gallery]').forEach(g => {
    const main = $('[data-gallery-main]', g);
    if (!main) return;
    let token = 0;
    const commit = (src, srcset, alt) => { main.src = src; main.srcset = srcset; main.alt = alt; };
    // Fundido: la foto nueva entra encima de la actual cuando ya cargó; al terminar reemplaza a la principal
    $$('[data-gallery-thumb]', g).forEach(th => th.addEventListener('click', () => {
      if (th.classList.contains('is-active')) return;
      $$('[data-gallery-thumb]', g).forEach(x => x.classList.toggle('is-active', x === th));
      const t = ++token, src = th.dataset.src, srcset = th.dataset.srcset || '', alt = th.dataset.alt || '';
      $$('.pdp__fade', main.parentElement).forEach(o => { if (o.classList.contains('is-in')) commit(o.src, o.srcset, o.alt); o.remove(); });
      const next = new Image();
      next.className = 'pdp__fade'; next.alt = alt; next.sizes = main.sizes; next.srcset = srcset; next.src = src;
      main.parentElement.appendChild(next);
      const done = () => { if (t !== token || !next.isConnected) return; commit(src, srcset, alt); next.remove(); };
      const show = () => {
        if (t !== token) { next.remove(); return; }
        requestAnimationFrame(() => requestAnimationFrame(() => next.classList.add('is-in')));
        next.addEventListener('transitionend', done, { once: true });
        setTimeout(done, 800);
      };
      (next.decode ? next.decode() : Promise.resolve()).then(show, show);
    }));
  });

  /* ---------- Cantidad ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const v = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(b.dataset.qty));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* Desplegables (<details>) que abren y cierran suavemente: ficha de producto, FAQ y cualquier otro. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', (e) => {
    const summary = e.target.closest('details > summary');
    if (!summary || reduce) return;
    const d = summary.parentElement;
    const body = [...d.children].filter((c) => c !== summary);
    if (!body.length || d.dataset.animating) return;
    e.preventDefault();
    d.dataset.animating = '1';
    const opts = { duration: 380, easing: 'cubic-bezier(.4,0,.2,1)' };
    const done = () => { delete d.dataset.animating; body.forEach((b) => { b.style.overflow = ''; }); };
    if (!d.open) {
      d.open = true;
      body.forEach((b) => {
        const h = b.scrollHeight;
        b.style.overflow = 'hidden';
        b.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], opts).onfinish = done;
      });
    } else {
      body.forEach((b, i) => {
        const h = b.scrollHeight;
        b.style.overflow = 'hidden';
        b.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], opts).onfinish = () => {
          if (i === body.length - 1) { d.open = false; done(); }
        };
      });
    }
  });
})();

/* Fundido de las fotos sobre la vista previa desenfocada (.lqip) */
(() => {
  const prep = (img) => {
    if ((img.complete && img.naturalWidth) || img.getAttribute('fetchpriority') === 'high') return;
    img.classList.add('is-loading');
    const show = () => img.classList.remove('is-loading');
    img.addEventListener('load', show, { once: true });
    img.addEventListener('error', show, { once: true });
  };
  document.querySelectorAll('.lqip img').forEach(prep);
})();
